// removed by extract-text-webpack-plugin
module.exports = {"container":"_3q6cJWrnDkt498A_5qY3Wq"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Home/Landing/styles.css
// module id = 1655
// module chunks = 83